import styled from 'styled-components';

export const NoteItemDotsSC = styled.div`
  width: auto;
  padding: 0px 15px 0px 15px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background: ${({ theme }) => theme.color.surface.baseline};

  .dots {
    width: 1px;
    height: 100%;
    margin-right: -2px;
    border-left: 2px dashed ${({ theme }) => theme.color.border.outline};
  }
`;

export const NoteItemSC = styled.div`
  width: 100%;
  height: auto;
  padding: 0px 20px 0px 0px;
  display: flex;

  .note-content {
    width: 100%;
    height: auto;
    padding-bottom: 20px;
    display: flex;
    flex-flow: row wrap;
    &__head {
      width: 100%;
      padding: 8px 12px 7px 12px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      background: ${({ theme }) => theme.color.surface.background};
      color: ${({ theme }) => theme.color.tint.primary};
      border-bottom: 1px solid ${({ theme }) => theme.color.border.emphasis};
      border-top-left-radius: ${({ theme }) => theme.radius.large}px;
      border-top-right-radius: ${({ theme }) => theme.radius.large}px;
    }
    &__body {
      width: 100%;
      background: ${({ theme }) => theme.color.surface.background};
      color: ${({ theme }) => theme.color.tint.primary};
      border-bottom-left-radius: ${({ theme }) => theme.radius.large}px;
      border-bottom-right-radius: ${({ theme }) => theme.radius.large}px;
    }
  }
`;
